import { z } from "zod";

export const absenceTypeForm = z.object({
	id: z.uuid(),
	name: z.string().min(1),
	requiresApproval: z.boolean().optional().default(false),
	requiresDocument: z.boolean().optional().default(false),
	deductsFromBalance: z.boolean().optional().default(false),
});

export const absenceCategoryForm = z.object({
	types: z.array(absenceTypeForm),
});

export type AbsenceTypeForm = z.infer<typeof absenceTypeForm>;
export type AbsenceCategoryForm = z.infer<typeof absenceCategoryForm>;
